import Lng from "../3x1010/Lng.js";
import Pqp from "../3x1010/Pqp.js";

import Globals from "../Globals.js";

import Swiper from "swiper/bundle";

// BASE PAGE
export default class PageCommon {
	constructor() {}
	init($data) {
		//Pqp.trace("PageCommon");
		this.metaInfo = $data && $data.metaInfo ? $data.metaInfo : null;
		//
		if (this.metaInfo) {
			history.replaceState(history.state, this.metaInfo.Title, this.metaInfo.Url + location.hash);
			document.title = metaInfo.Title;
		}

		//
		// dispaccio un evento globale
		//this.dispatchInitEvent(TheDisp.EV_PAGECOMMON_INITED);

		this.maxWidthMobile = 810;

		this.initModalBCorp();
	}

	initModalBCorp() {
		const btn = $(".js-learn-more-bcorp");
		const modal = $("#modalBcorp");
		btn.on("click", e => modal.fadeIn());
		$(".btn-close", modal).on("click", e => modal.fadeOut());
	}

	dispatchInitEvent(evenTyepe) {
		// dispaccio un evento globale
		let ev = new Event(evenTyepe);
		ev.payload = { page: this };
		TheDisp.dispatchEvent(ev);
	}

	get isHomepage() {
		return false;
	}

	showPreloader(flag) {
		if (flag) {
			jQuery(".js-preloader").show();
		} else {
			jQuery(".js-preloader").hide();
		}
	}

	static showPreloader(flag) {
		if (flag) {
			jQuery(".js-preloader").show();
		} else {
			jQuery(".js-preloader").hide();
		}
	}

	track() {
		if (Globals.SHOW_TRACKING_DATA) {
			console.log("---tracking---");
			console.log("Event: " + PageCommon._normalizza_track_prop(o.event));
			console.log("Category: " + PageCommon._normalizza_track_prop(o.category));
			console.log("Label: " + o.label ? PageCommon._normalizza_track_prop(o.label) : "n/a");
		}

		let additional = {
			event_category: PageCommon._normalizza_track_prop(o.category),
		};
		if (o.label) {
			additional.event_label = PageCommon._normalizza_track_prop(o.label);
		}

		gtag("event", PageCommon._normalizza_track_prop(o.event), additional);
	}

	_normalizza_track_prop(s) {
		let ret = s.toLowerCase();
		ret = Pqp.safeReplace(ret, " ", "_");
		ret = Pqp.safeReplace(ret, "'", "_");
		ret = Pqp.safeReplace(ret, ".", "");
		ret = Pqp.safeReplace(ret, ",", "");
		ret = Pqp.safeReplace(ret, "(", "_");
		ret = Pqp.safeReplace(ret, ")", "");
		ret = Pqp.safeReplace(ret, "__", "_");
		return ret;
	}

	static disable(mc, lFlag, opacity = 1) {
		if (lFlag) {
			mc.css("pointer-events", "none");
			mc.css("opacity", opacity);
		} else {
			mc.css("pointer-events", "all");
			mc.css("opacity", 1);
		}
	}

	headerEventHandler(e) {
		if (e.type === Header.EVENT_OPEN_LOGIN) {
			this.showLogin();
		}
		if (e.type === Header.EVENT_OPEN_LOGOUT) {
			this.showTestIndirizzo();
			//this.showLogout();
		}
	}

	showLogin() {
		/*let initer = {};
        initer.template = "template-login";
        initer.cls = LoginPanel;
        initer.closeButton = false;
        initer.size = LayersSize.NONE;
        initer.handler = this.loginEventsHandler.bind(this);*/

		let initer = {
			template: "template-login",
			cls: LoginPanel,
			closeButton: false,
			size: LayersSize.NONE,
			handler: this.loginEventsHandler.bind(this),
		};

		let panelLogin = new PanelWindow(initer);
		panelLogin.init();
	}

	loginEventsHandler(e) {
		//this.header.updateLoginLogout();
		if (e.additionalData) {
			if (e.additionalData.action === "showRecuperaPassword") {
				this.showRecuperaPassword();
			}
			if (e.additionalData.action === "showRegistrazioneLight") {
				this.showRegistrazioneLight();
			}
		}
	}

	showLogout() {
		/*let initer = {};
        initer.title = Lng.l("Auth.ConfirmTitleLogout");
        initer.body = Lng.l("Auth.ConfirmBodyLogout");
        initer.buttons = [Lng.l("Auth.ConfirmConfirmYes"), Lng.l("Auth.ConfirmConfirmNo")];
        initer.handler = this.logoutEventsHandler.bind(this);*/

		let initer = {
			title: Lng.l("Auth.ConfirmTitleLogout"),
			body: Lng.l("Auth.ConfirmBodyLogout"),
			buttons: [Lng.l("Auth.ConfirmConfirmYes"), Lng.l("Auth.ConfirmConfirmNo")],
			handler: this.logoutEventsHandler.bind(this),
		};

		let confirm = new ConfirmWindow(initer);
	}

	logoutEventsHandler(e) {
		if (e.index === 0) {
			this.doLogout();
			//this.showCambiaPassword();
		}
	}
	doLogout() {
		this.showPreloader(true);
		let rq = {
			ForceClearPrincipal: true,
		};
		thatServiceManeger.standardCall("/api/auth/logout", rq, this.doLogoutFeedback.bind(this));
	}

	doLogoutFeedback(e) {
		this.showPreloader(false);
		//this.header.updateLoginLogout();
		// qui dovrei controllare l'esito del logout per poi cosa? Dargli una alert che il logout è fallito? Boh.
		// Ma poi quando cazzo mai fallisce il logout? Se fallisce vuol dire che il server è in palla e allora tanto vale che non cambi nulla.
		// Probabilmente ci sarei stato meno a fargli vedere la alert che a scrivere queste cazzate ma va bene lo stesso.
	}

	// Da ricommentare se Manca cambia idea e non viene più invocato da qui ma direttamente dalla classe del login
	showRecuperaPassword() {
		let initer = {
			template: "template-recupera-password-step-0",
			cls: RecuperaPasswordStep0Panel,
			closeButton: false,
			size: LayersSize.NONE,
		};
		let panelRecuperaPassword = new PanelWindow(initer);
		panelRecuperaPassword.init();
	}

	showCambiaPassword() {
		let initer = {
			template: "template-cambia-password",
			cls: CambiaPasswordPanel,
			closeButton: false,
			size: LayersSize.NONE,
		};

		let panelCambiaPassword = new PanelWindow(initer);
		panelCambiaPassword.init({ UserName: Helper.getUserName() });
	}

	showRegistrazioneLight() {
		let initer = {
			template: "template-registrazione-light",
			cls: RegistrazioneLightPanel,
			closeButton: false,
			size: LayersSize.NONE,
			handler: this.registrazioneLightEventsHandler.bind(this),
		};

		let panelRegistrazioneLight = new PanelWindow(initer);
		panelRegistrazioneLight.init();
	}

	registrazioneLightEventsHandler(e) {
		if (e.additionalData) {
			if (e.additionalData.action === "showRecuperaPassword") {
				this.showRecuperaPassword();
			}
			if (e.additionalData.action === "showLogin") {
				this.showLogin();
			}
		}
	}

	showTestIndirizzo() {
		let initer = {
			template: "template-test-indirizzo",
			cls: TestIndirizzoPanel,
			closeButton: false,
			size: LayersSize.NONE,
		};

		let panelTestIndirizzo = new PanelWindow(initer);
		panelTestIndirizzo.init();
	}

	colorlink() {
		var links = document.getElementsByClassName("random-color");
		var colours = ["#de007a", "#516fb4", "#ba8600"];
		for (var a = 0; a < links.length; a++) {
			var randomColour = colours[Math.floor(colours.length * Math.random())];
			links[a].style.color = randomColour;
		}
	}

	bindEvents() {
		$(".js-toggle-class").off("click");
		$(".js-toggle-class").bind("click", function (e) {
			e.preventDefault();
			var $this = $(this);
			var tg = $this.attr("href") || $this.attr("data-target");
			var name = $this.attr("data-name") || "";
			if (tg) {
				$(tg).toggleClass(name);
				$this.toggleClass("toggled");
			}
		});

		//Menu mobile
		if (window.innerWidth <= this.maxWidthMobile) {
			$(".has-submenu>.nav-link").off("click");
			$(".has-submenu>.nav-link").bind("click", function (e) {
				e.preventDefault();
				var tg = $("~.submenu", this);
				if (tg) {
					$(tg).toggleClass("mob-visible");
				}
			});
		}
	}

	setPlugins() {
		$(".swiper-container").each(function (index) {
			$(this).attr("id", "swiper" + index);
			var name = $(this).attr("data-name") || "swiper-button";

			new Swiper("#swiper" + index, {
				slidesPerView: "auto",
				spaceBetween: 20,
				breakpoints: {
					768: {
						spaceBetween: 10,
					},
				},
				navigation: {
					nextEl: "." + name + "-next",
					prevEl: "." + name + "-prev",
				},
			});
		});
		$("#share").jsSocials({
			showCount: false,
			showLabel: false,
			shares: [
				{
					share: "facebook",
					logo: "fab fa-facebook-f",
				},
				{
					share: "twitter",
					logo: "fab fa-twitter",
				},
			],
		});
	}

	setupMenu() {
		if (window.innerWidth > this.maxWidthMobile) {
			const headerHeight = document.querySelector("header").getBoundingClientRect().height - 50;
			const windowHeight = window.innerHeight - headerHeight;
			const secondLevels = document.querySelectorAll(".nav-item");
			Array.from(secondLevels).map((subitem) => {
				subitem.addEventListener("mouseover", (event) => {
					const submenu = event.currentTarget.querySelector(".submenu");
					if (submenu) {
						let submenuRect = submenu.getBoundingClientRect();
						if (submenuRect.height > windowHeight) {
							submenu.querySelector(".nav").style.gridTemplateColumns = `repeat(${Math.ceil(submenuRect.height / windowHeight)}, 1fr)`;
						}
						submenuRect = submenu.getBoundingClientRect();
						if (submenuRect.top < 0) {
							submenu.style.bottom = `${submenuRect.top - headerHeight}px`;
						}
						if (submenuRect.left + submenuRect.width > window.innerWidth) {
							submenu.style.left = `${-submenuRect.width}px`;
						}
					}
				});
			});
		}
		document.querySelector(".search-btn").addEventListener("click", () => {
			setTimeout(() => {
				document.querySelector(".search-modal form input").focus();
			}, 600);
		});
		document.querySelector(".search-modal form").addEventListener("submit", (event) => {
			event.preventDefault();
			this.onSearch_q(true, event);
		});
		document.querySelector(".search-modal form input").addEventListener("keyup", (event) => {
			event.preventDefault();
			this.onSearch_q(true, event);
		});
	}

	onSearch_q(bPress, event) {
		let minlen = 2;
		let txt = $.trim($(".jsSearch_q").val());
		let tokens = txt.split(/[ \r\n\t;,.:\-_!\"/\\?^\[\]<>()%?*~+'|&]+/);
		let isValid = false;
		for (var x of tokens) if (x.length >= minlen) isValid = true;
		if (isValid) $(".jsSearch_qbtn").removeClass("disabled");
		else $(".jsSearch_qbtn").addClass("disabled");
		//
		// console.log(event.keyCode);
		if (bPress && (event.keyCode || event.which) == 13 && isValid) {
			this.showPreloader(true);
			document.querySelector(".search-modal form").submit();
			$(".jsSearch_q").val("");
		}
	}

	static isMobile() {
		let mobile = false;
		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
			mobile = true;
		}
		let isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
		if (isIOS) {
			mobile = true;
		}
		return mobile;
	}
}
